import { PresignLinkRequest } from 'src/shared/interface/user_profile';
import request from './request';

export async function getMasterData(data: any) {
  const url = '/api/masterdata/get-by-code';
  const res = await request('get', url, data);
  if (res?.isSucceeded) {
    return res?.data;
  }
}

export async function getPresignLinks(data: PresignLinkRequest) {
  const url = '/presign';
  const res = await request('post', url, data, { headers: { 'No-Auth': true } });
  if (res?.isSucceeded) {
    return res?.data;
  }
}
export async function getSimMode() {
  const url = '/api/active-sim/sim-mode';
  const res = await request('get', url);
  if (res?.isSucceeded) {
    return res?.data;
  }
}
